<template>
  <div>
    <div class="open-box">
      <img class="open-home" src="@/assets/img/mobile-img/home-tabbar.png" @click="$router.push('/')" />
      <img class="open-logo" src="@/assets/img/mobile-img/zw-logo.png" />
      <h3 class="open-text">中文知识网</h3>
      <div class="open-btn" @click="openApp">打开APP</div>
    </div>
    <van-overlay :show="wxShow" @click="wxShow = false">
      <div class="wrapper">
        <img style="width: 100%" src="@/assets/img/mobileImg/openweb.png" alt="" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      wxShow: false,
    };
  },
  methods: {
    openApp() {
      var u = navigator.userAgent;
      var isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      if (isAndroid) {
        // 微信内
        // if (isWeixin) {
        // this.wxShow = true
        let params = encodeURIComponent(
          `appcnknowledge://com.china.knowledgemesh?${encodeURIComponent(this.eliminate(
            "android"
          ))}`
        );
        window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.china.knowledgemesh&android_schema=${params}`;
        // } else {
        //   Toast.loading({
        //     message: '加载中...',
        //     forbidClick: true,
        //     loadingType: 'spinner',
        //         duration: 3000,
        //   })
        //   let params = encodeURIComponent(this.eliminate('android'))
        //   //安卓app的scheme协议
        //   window.location.href =
        //   `android://com.china.knowledgemesh?url=${params}`;
        //   var openTime = +new Date()
        //   setTimeout(async () => {
        //     if ((+new Date() - openTime > 2500)){
        //       // 下载地址
        //       let url = await this.getAndroidVersion()
        //       window.location.href = url;
        //     }
        //   }, 3000);
        // }
        // }
      }
      if (isIOS) {
        // ios
        let params = encodeURIComponent(this.eliminate("ios"));
        // 修改域名 区分 ios 下载App 与 会议资料下载 （新域名 zwopen 经网关仍跳转中文知识网下载页）
        window.location.href = `https://zwopen.cnknowledge.com/openIos?url=${params}`;
      }
    },
    eliminate(system) {
      // 跳转链接处理
      let url = document.location.toString();
      let urlArr = url.split("?");

      let paramsArr = urlArr[1].split("&");
      let params = Object.create(null);
      //循环路径中的参数剔除一些特殊参数
      paramsArr.forEach((item) => {
        item = item.split("=");
        if (
          item[0] !== "out" &&
          item[0] !== "app" &&
          item[0] !== "share" &&
          item[0] !== "token"
        ) {
          params[item[0]] = item[1];
        }
      });

      let baseUrl = urlArr[0] + "?";
      // 判断是否是学者,期刊,机构,名录页,增加app参数
      if (
        baseUrl.indexOf("appusesbaijia") !== -1 ||
        baseUrl.indexOf("appusesbaike") !== -1 ||
        baseUrl.indexOf("appusesjigou") !== -1 ||
        baseUrl.indexOf("appusesinstitutions") !== -1
      ) {
        params.app = system;
      }

      params.out = system;
      for (const key in params) {
        baseUrl = baseUrl + [key] + "=" + params[key] + "&";
      }
      return baseUrl;
    },
    async getAndroidVersion() {
      const res = await axios.get(
        `${process.env.NODE_ENV === "development" ? this.$global.url : ""
        }/zw-public/version/nf/getNewestVersion`,
        { headers: { deviceType: "android" } }
      );
      if (res.status === 200 && res.data.resultCode === "200") {
        return res.data.data.upgradePath;
      } else {
        this.$Message.error("数据获取异常");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.open-box {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding-top: env(safe-area-inset-top);
  padding-top: cconstant(safe-area-inset-top);
  width: 100%;
  height: calc(constant(safe-area-inset-top) + 44px);
  height: calc(env(safe-area-inset-top) + 44px);
  background-color: #fff;

  .open-home {
    margin-left: 21px;
    width: 20px;
    height: 20px;
  }

  .open-logo {
    margin-left: 25px;
    width: 36px;
    height: 36px;
  }

  .open-text {
    margin-left: 10px;
    font-size: 14px;
    color: #333333;
  }

  .open-btn {
    margin-left: 100px;
    padding: 6px 13px;
    background-color: #4a79f1;
    border-radius: 15px;
    color: #fff;
    font-size: 13px;
  }
}

::v-deep .van-overlay {
  z-index: 999;

  .wrapper {
    // height: 100%;
    padding: 0 5%;
    display: flex;
    justify-content: center;
  }
}
</style>